import { Alert, Box } from "@mui/material";
import styled from "styled-components";
import { styled as MStyled } from "@mui/system";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import TextField from "@mui/material/TextField";
const variantColorMapping = {
  primary: {
    backgroundColor: "--primary-button-bg",
    color: "--primary-button-text",
  },
  secondary: {
    backgroundColor: "--secondary-btn-color",
    color: "--secondary-btn-text",
  },
};
export const StyledButton = styled.button`
  background-color: ${(props) =>
    `var(${
    variantColorMapping[props.variantstyle] ?.backgroundColor ||
      "--primary-button-bg"
    })`};
  color: ${(props) =>
    `var(${
    variantColorMapping[props.variantstyle] ?.color || "--primary-button-text"
    })`};
  text-transform: none;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  outline: 0;
  border: 0;
  margin: 0;
  padding: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: middle;
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.75;
  letter-spacing: 0.02857em;
  text-transform: uppercase;
  min-width: 64px;
  padding: 6px 16px;
  border: 0;
  -webkit-transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  padding: 6px 8px;
  --variant-textColor: var(--mui-palette-primary-main);
  --variant-outlinedColor: var(--mui-palette-primary-main);
  --variant-outlinedBorder: rgba(var(--mui-palette-primary-mainChannel) / 0.5);
  --variant-containedColor: var(--mui-palette-primary-contrastText);
  --variant-containedBg: var(--mui-palette-primary-main);
  border-radius: 5px;
  &.primary-outline {
    background-color: transparent;
    color: var(--primary-button-bg);
    border: 1px solid var(--primary-button-bg);
  }
  &.primary-outline:hover {
    background-color: var(--primary-button-bg);
    color: var(--white);
  }
  &.primary-danger-outline {
    background-color: transparent;
    color: var(--mui-palette-Alert-errorIconColor);
    border: 1px solid var(--mui-palette-Alert-errorIconColor);
  }
  &.primary-danger-outline:hover {
    background-color: var(--mui-palette-Alert-errorIconColor);
    color: var(--white);
  }
  span.tma_btn_spinner {
    width: 32px !important;
    height: 32px !important;
    svg {
      height: 32px;
    }
  }
  span.tma_btn_custom_icon {
    display: flex;
    // position: relative;
    // top: 4px;
    // margin-left: 0.25rem;
    // left:6px;
    // scale:1.1;
    // svg{
    //   height:20px;
    // }
  }
  span.tma_btn_text {
    margin-left: 0.25rem;
  }
`;
const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};
export const Label = MStyled("label")(
  ({ theme }) => `
    font-family: Poppins;
    font-size: 0;
    display: block;
    margin-bottom: 4px;
    font-weight: 400;
    color: ${theme.palette.mode === "dark" ? grey[400] : grey[700]};
    `
);
export const StyledProgressBox = styled(Box)`
  .tma_progress_bar {
    height: 15px;
    > span {
      background-color: inherit;
    }
  }
`;
export const StyledFileList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  .file_download {
    color: #0766d4 !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .file_download:hover {
    text-decoration: underline;
    cursor: pointer;
  }
  li.tma_file_item {
    display: flex;
    align-items: anchor-center;
    background-color: rgba(0, 0, 0, 0.06);
    gap: 0.5rem;
    padding: 0.35rem;
    border-radius: 5px;
    svg {
      height: 25px;
      width: 25px;
    }
    a {
      color: var(--navy);
      font-size: 14px;
      text-transform: lowercase;
    }
    button.tma_file_remove {
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 20px;
      color: red;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
export const StyledAlert = styled(Alert)`
  width: 100%;
  margin-bottom: 1rem;
`;
export const StyledVisibilityOnIcon = styled(Visibility)`
  fill: var(--pro-blue);
  height: 20px;
`;
export const StyledVisibilityOffIcons = styled(VisibilityOff)`
  fill: var(--pro-blue);
  height: 20px;
`;

export const StyledTextField = styled(TextField)`
  padding: 0;
  width: 100%;
  label {
    font-size: 14px;
    transform: ${(props) =>
    props.value
      ? "translate(14px, -9px) scale(0.75)"
      : "translate(10px, 11px) scale(1)"};
    &.Mui-focused {
      transform: translate(14px, -9px) scale(0.75);
    }
  }
  input {
    padding: 5px 12px;
    font-size: 14px;
    height: 30px;
    width: 100%;
    &:placeholder {
      font-size: 14px;
    }
    &.MuiOutlinedInput-input:-webkit-autofill {
      padding: 5px 12px !important;
      font-size: 14px !important;
      height: 30px !important;
      width: 100% !important;
      &:placeholder {
        font-size: 14px !important;
      }
    }
  }
`;
